import React from 'react';
import { NavbarProps } from 'features/navbar/types';
import { NavList } from '../NavList/NavList';

type MobileBottomHeaderProps = Omit<
  NavbarProps,
  'brandLogo' | 'userInitials' | 'handleLogout' | 'onBrandLogoClick'
>;

export const MobileBottomHeader = ({
  onTabChange,
  selectedTab,
  navItemList,
}: MobileBottomHeaderProps) => (
  <NavList
    tabContainerStyle={{ flex: 1, justifyContent: 'space-between' }}
    selectedTab={selectedTab}
    onTabChange={onTabChange}
    hideTabIndicator
    navItemList={navItemList ?? []}
  />
);
